import { Flex, Heading } from "@aws-amplify/ui-react";
import * as React from "react";

export default function FreeTrial() {
  return (
    <Flex
      width={"100%"}
      height={"100%"}
      justifyContent={"center"}
      alignItems={"center"}
    >
      <Heading>Enjoy your 30-day free trial!</Heading>
    </Flex>
  );
}
